import { NEXT_PUBLIC_GOOGLE_FONTS_API_KEY } from '@utils/client-side-config'
import { useEffect, useState } from 'react'
import { IGoogleFont } from './briefFontSelection.types'

const GOOGLE_FONTS_ROOT_URL = 'https://www.googleapis.com/webfonts/v1/webfonts'

function useGoogleFonts() {
  const [googleFonts, setGoogleFonts] = useState<IGoogleFont[]>(null)
  const [error, setError] = useState<string>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const getGoogleFonts = async () => {
    try {
      setLoading(true)
      const responseWithFonts = await fetch(
        `${GOOGLE_FONTS_ROOT_URL}?key=${NEXT_PUBLIC_GOOGLE_FONTS_API_KEY}`
      )
      const fonts = (await responseWithFonts.json()).items

      setGoogleFonts(fonts || null)
    } catch (e) {
      setError(e.message || 'Something went wrong.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getGoogleFonts()
  }, [])

  return { googleFonts, error, loading }
}

export { useGoogleFonts }
